export interface Report {
  id: string;
  reportDateISO: string;
  name: string;
  fileType: string;
  source: ReportSource;
}

export enum ReportSource {
  IHubShared = 'IHUB_SHARED',
  IHubOrganization = 'IHUB_ORGANIZATION',
  Crossroads = 'CROSSROADS',
}

export type IHubSource =
  | ReportSource.IHubShared
  | ReportSource.IHubOrganization;
